export const B2B_PAYMENT_TYPES = {
  DIRECT_PAYMENT: 'direct',
  CREDIT: 'credit',
} as const

export const B2B_CREDIT_CHANGE_TYPES = {
  INCREASE: 'increase',
  DECREASE: 'decrease',
} as const

export const B2B_DELIVERY_TYPES = {
  ASAP: 'asap',
  SCHEDULED: 'scheduled',
} as const

export const B2B_OPERATING_WEEKDAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
